export default [
    {
        slug: 'deadly-questions',
        name: 'Deadly Questions',
        client: 'Australia Victoria Government',
        campaignYear: '2018',
        short_description: 'Deadly Questions lets people ask Aboriginal Victorians the questions they\'ve always wanted answered',
        coverImg: 'cover.png',
        initials: 'DQ',
        url: {
            isAvailable: true,
            href: 'https://deadlyquestions.vic.gov.au'
        },
        tech: [
            'VUE.js',
            'SCSS',
            'Serverless',
            'DynamoDB',
            'Node.js',
            'GraphQL',
            'GSAP',
            'WCAG 2.0 AA'
        ],
        paragraphs: [
            {
                type: 'text',
                content: 'Deadly Questions is a web platform that pushes the public to ask all sort of questions to the Aboriginal community. It followed research that revealed the state’s citizens don’t know much about Aboriginal culture, heritage or current affairs. The research also highlighted that many were uncomfortable with asking questions about these topics out of fear of offending or appearing ignorant'
            },
            {
                type: 'img',
                heading: '<span class="highlight">You ask. Aboriginal Victorian answer</span>',
                content: 'preview.jpg'
            },
            {
                type: 'text',
                content: 'This project is split in two sections. One, which is the public website where ultimately the users can submit their questions and watch, read or listen to the final answers; the other, a bespoke CMS for dealing with the question submission and answering process.'
            },
            {
                type: 'text',
                content: 'The latter, consents to admins to keep track of the questions that have been submitted from the public and to see the ones that are still waiting for an answer. Contributors of this campaign from the aboriginal community, can login and see these same questions and reply through a video, an audio or simply a text.'
            },
            {
                type: 'img',
                heading: '<span class="highlight">CMS - admin view</span>',
                content: 'dq-answer-feed.png'
            },
            {
                type: 'img',
                heading: '<span class="highlight">CMS - contributors view</span>',
                content: 'dq-contrib-reply.png'
            },
            {
                type: 'img',
                heading: '<span class="highlight">CMS - contributors view</span>',
                content: 'dq-contrib-txt.png'
            },
            {
                type: 'text',
                content: 'Both platforms are WCAG 2.0 AA compliant, and fully accessible for auditive, cognitive, physical or visual disabilities. They have been built using VueJS as Framework, GraphQL for the communication with the Databases, Nodejs and Aws services.'
            },
            {
                type: 'text',
                content: 'My role has been to reproduce the look and feel for both platform based of the designs.'
            },
        ]
    },
    {
        slug: 'nab-yourselfie',
        name: 'Nab Yourselfie',
        short_description: 'A web app that utilises facial and voice recognition for NAB.',
        client: 'National Australia Bank',
        coverImg: 'faces.jpg',
        campaignYear: '2018',
        initials: 'Yourselfie',
        url: {
            isAvailable: false,
            href: ''
        },
        tech: [
            'VUE.js',
            'AWS Serverless',
            'AWS S3',
            'Amazon Rekognition',
            'Web Speech API',
            'IBM Watson',
            'WebRTC',
            'Node.js',
            'GSAP',
            'SCSS',
            'Lottie Animation',
            'WCAG 2.0 AA',
        ],
        mainAsset: {
            type: 'video',
            src: '../video/tech-video.mp4',
            poster: 'final-result.jpg'
        },
        paragraphs: [
            {
                type: 'text',
                content: 'It\'s a web app designed to help you have a conversation with yourself and visualise what you really want in life so you can make your dreams a reality. This piece of work encourage the users to do a deep reflection on their ambitions through a unique experience after which generates a piece of art based on the user.'
            },
            {
                type: 'img',
                content: 'how-it-works.png'
            }, 
            {
                type: 'img',
                heading: '<span class="highlight">Yourselfie experience</span>',
                content: 'experience.gif'
            }, 
            {
                type: 'text',
                content: 'My role was to respect look and feel designed for this web app following WCAG 2.0 AA compliant, to ensure a fully accessible experience. I\'ve worked on the text speech analysis to make sure that specific icons where triggered, so to make possible that the avatar will take shape.'
            },
            {
                type: 'text',
                content: 'WebRTC to take the selfie, Facial recognition through Amazon Rekognition services, Text speech Analysis with IBM Watson and Web Speech API. Backend built using Serverless Framework and Node.js, Frontend built using VUE.js, Webpack, Html5, Sass, ES6 JavaScript, GSAP, Lottie Animations.'
            },
        ]
    },
    {
        slug: 'dq-alexa',
        name: 'DQ Alexa Skill',
        client: 'Australia Victoria Government',
        short_description: 'Voice skill that enounche the web platform experience',
        coverImg: 'alexa.jpg',
        campaignYear: '2018',
        initials: 'DQ Alexa',
        url: {
            isAvailable: true,
            href: 'https://www.amazon.com.au/dp/B07MX3YSS6/'
        },
        tech: [
            'AWS S3',
            'Node.js',
            'FFMPEG',
            'AWS Lambda',
            'AWS DynamoDB',
            'AWS Alexa SDK'
        ],
        paragraphs: [
            {
                type: 'text',
                content: 'Building on the success of the campaign and leveraging the rich library of questions submitted via the public and responded to by the campaign\'s Aboriginal champions, the Deadly Questions Alexa Skill provides a new, voice-activated way for Victorians to engage in the discussion.'
            }, 
            {
                type: 'img',
                content: 'cover.jpg'
            }, 
            {
                type: 'text',
                content: 'As conversational interfaces work differently from visual interfaces, we reimagined how audiences access the content. This is how we ended up with 2 different paths: a quick and easy question of the day, and questions organised by topic to emphasise discovery.'
            },
            {
                type: 'text',
                content: 'To deliver on a rich and engaging user experience, we\'ve decided to make use of the new Alexa Presentation Language (or APL), allowing us to deliver on things like graphics, and touch events to complement the overall experience where we thought it was necessary.'
            },
            {
                type: 'text',
                content: 'To deliver on a rich and engaging user experience, we\'ve decided to make use of the new Alexa Presentation Language (or APL), allowing us to deliver on things like graphics, and touch events to complement the overall experience where we thought it was necessary.'
            },
            {
                type: 'video',
                src: 'https://player.vimeo.com/video/312666984?byline=0&portrait=0&title=0#t='
            },
            {
                type: 'text',
                content: '<span class="highlight">Awards:</span>'
            },
            {
                type: 'text',
                content: 'Amazon Alexa Skills Challenge: Multimodal WINNER Bonus Prize - Best Multimodal Experience, Australia Store Skills'
            }
        ]
    },
    {
        slug: 'myer-global-position-stockings',
        name: 'Global Position Stockings',
        client: 'Myer',
        campaignYear: '2019',
        short_description: 'Your direct link to Santa',
        coverImg: 'cover.jpg',
        initials: 'GPS',
        url: {
            isAvailable: false,
            href: 'https://myerstocking.com.au/'
        },
        tech: [
            'VUE.js',
            'WEBGL',
            'Babylon.js',
            'Lottie Animation',
            'GSAP',
            'SCSS',
            'Serverless',
            'AWS Amplify'
        ],
        mainAsset: {
            type: 'video',
            srcExt: 'https://www.youtube.com/embed/nhk5omUqXms',
            poster: 'cover.jpg'
        },
        paragraphs: [
            {
                type: 'text',
                content: 'For this year\'s MYER Christmas campaign, Clemenger created a Global Positioning Stocking - "a connected product that ensures Santa can find everyone this Christmas".'
            },
            {
                type: 'text',
                content: 'The MYER Global Positioning Stocking pair with MYER Connect, a digital ecosystem that connects IoT products with cross-channel experiences. It also gives kids access to a crafted web experience where they can follow\'s Father Christmas journey on Christmas Eve, on an interactive 3D planet...'
            },
            {
                type: 'img',
                content: 'globe.jpg'
            },
            {
                type: 'text',
                content: '...send drawings and letters to Santa and share their Wishlist with the North Pole;'
            },
            {
                type: 'img',
                content: ['postcard.gif', 'wishlist.gif']
            },
            {
                type: 'img',
                content: 'write-letter.jpg'
            },
            {
                type: 'text',
                content: 'Accessible from the native app, parents and their kids can access to a crafted web experience designed around the connected Christmas Stocking.'
            },
            {
                type: 'img',
                heading: '<span class="highlight">Parents Dashboard</span>',
                content: 'parent-section.jpg'
            },
        ]
    },
    // {
    //     slug: 'punisher-cli-tool',
    //     name: 'Edm CLI Template',
    //     client: 'Clemenger',
    //     campaignYear: '2019',
    //     coverImg: 'cover.jpg',
    //     short_description: 'Cli tool that menages edms development',
    //     url: {
    //         isAvailable: false,
    //         url: ''
    //     },
    //     mainAsset: {
    //         type: 'img',
    //         src: 'punisher.gif'
    //     },
    //     paragraphs: [
    //         {
    //             type: 'text',
    //             content: 'Hired as Junior Developer at Clemenger, I started my career developing EDMs and Banners for a different stack of clients with different requirements.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'The edm template that at that point was being used was a very good tool, using one of the most popular Frameworks for Edms, Inky Foundation library. Through this template I started learning the do and don\'ts of edms, all the edge case scenarios and the multiple problems with Outlook.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'However, for more complicated templates this library was resulting quite big in the final file size, so I decided to build one on my own which was using basic Handlebars template and SCSS which at the end gets compiled into CSS and then inline into HTML style attribute.'
    //         },
    //         {
    //             type: 'img',
    //             heading: '<span class="highlight">Create</span>',
    //             src: 'https://media.giphy.com/media/gFPDcZymncYBQStkVo/giphy.gif'
    //         },
    //         {
    //             type: 'img',
    //             heading: '<span class="highlight">Send</span>',
    //             src: 'https://media.giphy.com/media/gk91V3iJjWRtkrpH0Q/giphy.gif'
    //         },
    //         {
    //             type: 'img',
    //             heading: '<span class="highlight">Upload</span>',
    //             src: 'https://media.giphy.com/media/hordlj1qP5e8U1WsXJ/giphy.gif'
    //         },
    //         {
    //             type: 'text',
    //             content: 'This new template consists of two parts: one for the server side and one for the client side. The server side, called punisher CLI is a CLI tool, the core of the template, that manages all the creation and compiled states of the template.. You can create a new edm project, you can run it on a local server that runs through node express, you can upload it on a AWS S3 bucket and you can send the edm out for testing to one or multiple email addresses and finally you can get the files ready to dispatch and hand over to client.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'The other part, instead, is a collection of different prebuilt modules, a main structure layout containing outlooks specific styles and helpers. In here I can create other modules and setup my edm'
    //         },
    //     ],
    //     tech: [
    //         'Handlebars',
    //         'Aws Services',
    //         'Node.js',
    //         'SCSS'
    //     ]
    // },
    // {
    //     slug: 'banner-tool',
    //     name: 'Banner Tool',
    //     client: 'Clemenger',
    //     campaignYear: '2019',
    //     coverImg: 'cover.jpg',
    //     short_description: 'Template to build banners easly',
    //     url: {
    //         isAvailable: false
    //     },
    //     // mainAsset: {
    //     //     type: 'img',
    //     //     src: '',
    //     //     poster: 'cover.png'
    //     // },
    //     paragraphs: [
    //         {
    //             type: 'text',
    //             content: 'Hired as Junior Developer at Clemenger, I started my career developing EDMs and Banners for a different stack of clients with different requirements.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'There was already a good template that helped us with the every day work around banners. In fact, through a series of GULP tasks, it was already able to compile SCSS code into CSS, open up a local server, displaying the single banners into a unique preview page and uploading them into an S3 bucket upon request.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'However we started to acquire different clients and as mentioned above that meant different requirements as well. We tried to automate the most repetitive tasks and with time there were few more that were added to our plate.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'We were required to check that the file size of each singular banner was respecting the specs and that the different creative sets of banners were made ready for different publishers at time. This means that each publisher need a specific snippet of code that inject the right logic for the click tag, the main feature when it comes to banners.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'Also what I\'ve noticed, was that building the banner per se didn\'t involve much time. What required time was the setup. Especially with Rich media banners, setup the right method and applying the right library making sure everything worked together.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'So my new banner tool, was a collection of the most used case scenarios, something that could be reused across the team without loosing consistency and quality of the result, like polite loading, auto-expandable, or Dynamic banners that were using external API for content.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'The Gulp tasks where update in a way that it could generate for meThe Gulp tasks where update in a way that it could generate for me all the variations I needed depending on which and how many publishers I picked at the end. Better privacy system was created, in fact instead of storing locally in the repository the credentials for our S3 bucket, I\'ve made use of AWS Secret manager so that only certain user could access it and gain access to the banner storage bucket. all the variations I needed depending on which and how many publishers I picked at the end. It also would calculate at front the file size of my images and displaying the result into the preview mode so I could check in real time if I was within requirements.'
    //         },
    //         {
    //             type: 'text',
    //             content: 'And finally, it would also calculate at front the file size of my images and displaying the result into the preview mode so I could check in real time if I was within requirements.'
    //         }
    //     ],
    //     tech: [
    //         'Gulp',
    //         'HMTL5',
    //         'Aws Services',
    //         'Node.js',
    //         'SCSS'
    //     ]
    // }
]
